export const SAMPLE_PROGRAM_EVALUATION_ROUTE = '/reports/program-evaluation/sample';
export const SAMPLE_PLAN_ROUTE = '/reports/student-action-plan/sample';
